import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const {
  colors: { ui },
} = constants;
const greyLight = ui.neutral[100];
const greyExtraLight = ui.neutral[25];

const { BreakpointNames } = constants.breakpoints;

export const loadingRootCss: CSSObject = {
  marginTop: 0,
};

export const loadingRowCss: CSSObject = {
  padding: "16px",
  display: "flex",
  gap: "10px",
  backgroundColor: greyExtraLight,
  "&:nth-of-type(even)": {
    backgroundColor: "white",
  },
  borderBottom: `1px solid ${greyLight}`,
  "& > div:nth-of-type(3)": {
    display: "none",
    [breakpoint.downTo(BreakpointNames.md)]: {
      display: "flex",
    },
  },
};

export const loadingThumbnailCss: CSSObject = {
  display: "flex",
  width: "60px",
  height: 60,
  borderRadius: "8px",
  overflow: "hidden",
};

export const loadingColumnCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: "8px 16px",
  "& > div": {
    height: 12,
    width: 153,
    borderRadius: "8px",
    overflow: "hidden",
  },
  "& > div:nth-of-type(2)": {
    width: 138,
  },
  "& > div:nth-of-type(3)": {
    width: 47,
  },
};

export const loadingSpinnerCss: CSSObject = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& > div": {
    margin: 0,
    width: "32px",
    height: "32px",
  },
  "&:nth-of-type(odd)": {
    display: "none",
    [breakpoint.downTo(BreakpointNames.md)]: {
      display: "flex",
    },
  },
};
